import SchemaFormAutoSubmit from "@/components/Schema/SchemaFormAutoSubmit";
import { PageHeader } from "@ant-design/pro-components";
import { createForm } from "@formily/core";
import { Button, Tabs } from "antd";
import { useMemo, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MMNavigationRoutes from "../../utils/navigationRoutes";

const AddChapterType: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const schemaIndividual = "Organization Type";

  const formIndividual = useMemo(() => createForm({}), []);

  const formIndividualRef = useRef<{ handleSave: () => Promise<void> }>(null);

  return (
    <>
      <PageHeader
        className="custom-page-header"
        title={id ? "Edit Organization Type" : "Add Organization Type"}
        onBack={() => navigate("/mm" + MMNavigationRoutes.CHAPTER_TYPE)}
      />

      <Tabs
        items={[
          {
            key: "1",
            label: "",
            children: (
              <>
                <SchemaFormAutoSubmit
                  form={formIndividual}
                  schemaName={schemaIndividual}
                  recordId={id}
                  ref={formIndividualRef}
                />
                <div className="flex justify-end gap-4">
                  <Button
                    type="primary"
                    onClick={async () => {
                      try {
                        await formIndividualRef.current?.handleSave();
                        navigate("/mm" + MMNavigationRoutes.CHAPTER_TYPE);
                      } catch (error) {
                        // Validation failed, don't redirect
                        console.log("Form validation failed:", error);
                      }
                    }}
                  >
                    Save
                  </Button>
                </div>
              </>
            ),
          },
        ]}
      />
    </>
  );
};

export default AddChapterType;
